import { useEffect, useState } from 'react';
import { getClientePrimeiroNome } from '../../domain/usecases/clienteDisplay';

interface Props {
  nome?:           string | null;
  avatarUrl?:      string | null;
  size?:           'sm' | 'md';
  showNome?:       boolean;
  className?:      string;
  nomeClassName?:  string;
}

const SIZE = {
  sm: { container: 'w-5 h-5', nome: 'text-xs', initials: 'text-[9px]' },
  md: { container: 'w-7 h-7', nome: 'text-sm', initials: 'text-xs' },
} as const;

export function ClienteAvatarChip({
  nome,
  avatarUrl,
  size = 'sm',
  showNome = true,
  className = '',
  nomeClassName = 'text-emerald-400',
}: Props) {
  const primeiro = getClientePrimeiroNome(nome);
  const [avatarBroken, setAvatarBroken] = useState(false);

  useEffect(() => {
    setAvatarBroken(false);
  }, [avatarUrl]);

  if (!primeiro) return null;

  const s = SIZE[size];

  return (
    <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`}>
      <span
        className={`${s.container} rounded-full bg-gradient-to-br from-orange-500/20 to-rose-500/20 border border-white/[0.08] flex items-center justify-center shrink-0 overflow-hidden`}
      >
        {avatarUrl && !avatarBroken ? (
          <img
            src={avatarUrl}
            alt=""
            className="w-full h-full object-cover"
            onError={() => setAvatarBroken(true)}
          />
        ) : (
          <span className={`${s.initials} font-bold text-orange-400`}>
            {primeiro.charAt(0).toUpperCase()}
          </span>
        )}
      </span>
      {showNome && (
        <span className={`${s.nome} font-medium truncate ${nomeClassName}`}>{primeiro}</span>
      )}
    </span>
  );
}
